import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_invoice,
  get_invoice,
  update_invoice,
} from "../../../../Controllers/Sales/Invoices";
import headers from "../../../../Data/Forms/Sales/Invoices/headers";
import Loadercomponent from "../../../../Componets/Loader";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import Invoicetable from "../../../../Data/Forms/Sales/Invoices/table";
import dayjs from "dayjs";
import BillingTable from "./table";

const BillingForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const [customer, setCustomer] = useState();
  const [refrence, setReference] = useState();

  const [customerPay, setCustomerPay] = useState();

  const [values, setValues] = useState([
    {
      name: "Invoices",
      className: "bg-white p-4 rounded-md p-8 w-[100%] mx-auto",
    },
  ]);

  const focus = useRef([]);

  const [details, setDetails] = useState([
    {
      id: "",
      description: null,
      name: "",
      unit: "",
      unit_name: "",
      unit_details_options: null,
      conversion: 0,
      quantity: "",
      invoice: "",
      invoice_price: "",
      invoice_options: null,
      delivered: "",
      tax: 0,
      free: "",
      barcode: "",
      price_per_unit: "",
      sale_price: "",
      expiry_date: "",
      tax_amount: "0.000",
      total: 0,
    },
  ]);

  const [totals, setTotals] = useState({
    subtotal: "0.000",
    taxamount: "0.000",
    discount: 0,
    delivery: 0,
    delivery_status: 2,
    delivery_date: dayjs(),
    payment_status: 2,
    payment_types: ["Cash"],
    /* payments: {
      Cash: "",
      "Debit card": "",
      "Credit card": "",
      "Bank transfer": "",
      "Online payment": "",
      Cheque: "",
    }, */
    payments: [{
      id: `temp-cash-initial`,
      name: "Cash",
      amount: ""
    }],
    paid: 0,
    remaining: 0,
    total: "0.000",
  });

  const detailsvalidation = (tabledata) => {
    let params = {};

    if (details?.length > 0) {
      let total = details?.length;
      let count = 0;

      let validated = [];
      details?.map((v, i) => {
        if (count == i) {
          if (!v?.description) {
            document.getElementById(
              `description${i}`
            ).textContent = `Description is required`;
            focus.current[`description${i}`].current.focus();
          }
          // else if (!v?.sale_price) {
          //   document.getElementById(
          //     `sale_price${i}`
          //   ).textContent = `Sale price is required`;
          //   focus.current[`sale_price${i}`].current.focus();
          // }
          else if (!v?.quantity) {
            document.getElementById(
              `quantity${i}`
            ).textContent = `Quantity is required`;
            focus.current[`quantity${i}`].current.focus();
          } else {
            document.getElementById(`description${i}`).textContent = ``;
            // document.getElementById(`sale_price${i}`).textContent = ``;
            document.getElementById(`quantity${i}`).textContent = ``;

            validated?.push(v);
            count++;
          }
        }
      });

      if (count == total) {
        params = {
          status: true,
          data: {
            ...tabledata,
            date: new Date(),
            details: validated,
            customer: customer,
            reference: refrence,
          },
        };

        return params;
      } else {
        params = {
          status: false,
          data: null,
        };

        return params;
      }
    } else {
      toast?.error("Details not found");
    }
  };

  const totalsvalidation = (tabledata) => {
    let params = {};

    let count_totals = 0;

    if (totals?.delivery_status == 2 && !totals?.delivery_date) {
      // document.getElementById(
      //   `delivery_date`
      // ).textContent = `Delivery Date is required`;
      // focus.current[`delivery_date`].current.focus();
    } else if (totals?.payment_status && !totals?.payment_types?.length) {
      document.getElementById(
        `payment_types`
      ).textContent = `Payment type is required`;
      focus.current[`payment_types`].current.focus();
    } else {
      if (totals?.delivery_status == 2) {
        // document.getElementById(`delivery_date`).textContent = ``;
      }
      if (totals?.payment_status) {
        document.getElementById(`payment_types`).textContent = ``;
      }
      count_totals++;
    }

    if (count_totals) {
      let total_payment_types = totals?.payment_types?.length;
      let count_payment_types = 0;

      let total_amount = 0;
      // if (totals?.payment_types?.length > 0) {
      //   //old 1
      //   // totals?.payment_types?.map((v, i) => {
      //   //   if (count_payment_types == i) {
      //   //     if (!totals?.payments?.[v]?.amount) {
      //   //       document.getElementById(`${v}`).textContent = `${v} is required`;
      //   //       focus.current[`${v}`].current.focus();
      //   //     } else {
      //   //       total_amount =
      //   //         parseFloat(total_amount || 0) +
      //   //         parseFloat(totals?.payments?.[v]?.amount || 0);
      //   //       document.getElementById(`${v}`).textContent = ``;
      //   //       count_payment_types++;
      //   //     }
      //   //   }
      //   // });

      //   //new 1
      //   /*   totals?.payment_types?.map((v, i) => {
      //       if (count_payment_types == i) {
      //         if (!totals?.payments?.[v]?.amount) {
      //           if (
      //             totals?.payment_status == 2 &&
      //             totals?.payment_types?.length == 1
      //           ) {
      //             count_payment_types++;
      //           } else {
      //             document.getElementById(
      //               `${v}`
      //             ).textContent = `${v} is required`;
      //             focus.current[`${v}`].current.focus();
      //           }
      //         } else {
      //           total_amount =
      //             parseFloat(total_amount || 0) +
      //             parseFloat(totals?.payments?.[v]?.amount || 0);
      //           if (
      //             totals?.payment_status == 2 &&
      //             totals?.payment_types?.length == 1
      //           ) {
      //             count_payment_types++;
      //           } else {
      //             document.getElementById(`${v}`).textContent = ``;
      //             count_payment_types++;
      //           }
      //         }
      //       }
      //     }); */

      //   /*  totals?.payment_types?.forEach((type, i) => {
      //      if (count_payment_types == i) {
      //        const paymentsOfType = totals?.payments?.filter(p => p.name === type) || [];
      //        const totalForType = paymentsOfType.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

      //        if (totalForType <= 0) {
      //          if (
      //            totals?.payment_status == 2 &&
      //            totals?.payment_types?.length == 1
      //          ) {
      //            count_payment_types++;
      //          } else {
      //            document.getElementById(
      //              `payment_type_${type}`
      //            ).textContent = `${type} payment is required`;
      //            focus.current[`payment_type_${type}`]?.current?.focus();
      //          }
      //        } else {
      //          total_amount = parseFloat(total_amount || 0) + totalForType;
      //          if (
      //            totals?.payment_status == 2 &&
      //            totals?.payment_types?.length == 1
      //          ) {
      //            count_payment_types++;
      //          } else {
      //            document.getElementById(`payment_type_${type}`).textContent = ``;
      //            count_payment_types++;
      //          }
      //        }
      //      }
      //    }); */

      //   // In your totalsvalidation function, update the payment validation section:
      //   totals?.payment_types?.forEach((type, i) => {
      //     if (count_payment_types == i) {
      //       const paymentsOfType = totals?.payments?.filter(p => p.name === type) || [];
      //       const totalForType = paymentsOfType.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

      //       // For single payment method, we don't need to validate amount
      //       if (totals?.payment_types?.length === 1) {
      //         count_payment_types++;
      //         total_amount = parseFloat(totals?.total || 0);
      //       } else if (totalForType <= 0) {
      //         // Multiple payment methods - validate each has amount
      //         if (totals?.payment_status == 2 && totals?.payment_types?.length == 1) {
      //           count_payment_types++;
      //         } else {
      //           document.getElementById(
      //             `payment_type_${type}`
      //           ).textContent = `${type} payment is required`;
      //           focus.current[`payment_type_${type}`]?.current?.focus();
      //         }
      //       } else {
      //         total_amount = parseFloat(total_amount || 0) + totalForType;
      //         document.getElementById(`payment_type_${type}`).textContent = ``;
      //         count_payment_types++;
      //       }
      //     }
      //   });

      //   // Check total payments don't exceed grand total
      //   if (total_amount > parseFloat(totals?.total || 0)) {
      //     toast?.error(`Total payments (${total_amount.toFixed(3)}) exceed order total (${parseFloat(totals?.total).toFixed(3)})`);
      //     params = { status: false, data: null };
      //     return params;
      //   }

      //   // if (total_amount == 0 && !tabledata?.customer) {
      //   //   toast?.error("Customer required for credit");
      //   // } else {

      //   //new 2
      //   if (count_payment_types == totals?.payment_types?.length) {
      //     if (
      //       totals?.payment_status == 2 &&
      //       totals?.payment_types?.length == 1
      //     ) {
      //       /*  let paymenttypedata = totals?.payment_types;
      //        let paymentdata = totals?.payments;

      //        paymenttypedata = [totals?.payment_types[0]];
      //        paymentdata = {};
      //        if (totals.payment_types[0] == "Cash") {
      //          paymentdata = {
      //            Cash: { amount: totals?.total },
      //            Cheque: "",
      //            "Debit card": "",
      //            "Credit card": "",
      //            "Bank transfer": "",
      //            "Online payment": "",
      //          };
      //        } else if (totals.payment_types[0] == "Cheque") {
      //          paymentdata = {
      //            Cash: "",
      //            Cheque: { amount: totals?.total },
      //            "Debit card": "",
      //            "Credit card": "",
      //            "Bank transfer": "",
      //            "Online payment": "",
      //          };
      //        } else if (totals.payment_types[0] == "Debit card") {
      //          paymentdata = {
      //            Cash: "",
      //            Cheque: "",
      //            "Debit card": { amount: totals?.total },
      //            "Credit card": "",
      //            "Bank transfer": "",
      //            "Online payment": "",
      //          };
      //        } else if (totals.payment_types[0] == "Credit card") {
      //          paymentdata = {
      //            Cash: "",
      //            Cheque: "",
      //            "Debit card": "",
      //            "Credit card": { amount: totals?.total },
      //            "Bank transfer": "",
      //            "Online payment": "",
      //          };
      //        } else if (totals.payment_types[0] == "Bank transfer") {
      //          paymentdata = {
      //            Cash: "",
      //            Cheque: "",
      //            "Debit card": "",
      //            "Credit card": "",
      //            "Bank transfer": { amount: totals?.total },
      //            "Online payment": "",
      //          };
      //        } else if (totals.payment_types[0] == "Online payment") {
      //          paymentdata = {
      //            Cash: "",
      //            Cheque: "",
      //            "Debit card": "",
      //            "Credit card": "",
      //            "Bank transfer": "",
      //            "Online payment": { amount: totals?.total },
      //          };
      //        } else {
      //          paymentdata = {
      //            Cash: "",
      //            Cheque: "",
      //            "Debit card": "",
      //            "Credit card": "",
      //            "Bank transfer": "",
      //            "Online payment": "",
      //          };
      //        } */

      //       params = {
      //         status: true,
      //         data: {
      //           ...tabledata,
      //           id: id ? id : "",
      //           subtotal: totals?.subtotal,
      //           taxamount: totals?.taxamount,
      //           discount: totals?.discount,
      //           delivery: totals?.delivery,
      //           // delivery_status: totals?.delivery_status,
      //           // delivery_date: totals?.delivery_date,
      //           // payment_status: totals?.payment_status,
      //           // payment_types: totals?.payment_types,
      //           // payments: totals?.payments,
      //           delivery_status: 2,
      //           delivery_date: new Date(),
      //           payment_status: 2,
      //           payment_types: totals?.payment_types,
      //           payments: totals?.payments,
      //           total: totals?.total,
      //         },
      //       };
      //     } else {
      //       params = {
      //         status: true,
      //         data: {
      //           ...tabledata,
      //           id: id ? id : "",
      //           subtotal: totals?.subtotal,
      //           taxamount: totals?.taxamount,
      //           discount: totals?.discount,
      //           delivery: totals?.delivery,
      //           delivery_status: totals?.delivery_status,
      //           delivery_date: totals?.delivery_date,
      //           payment_status: totals?.payment_status,
      //           payment_types: totals?.payment_types,
      //           payments: totals?.payments,
      //           total: totals?.total,
      //         },
      //       };
      //     }

      //     return params;
      //   }
      //   // old 2
      //   // if (count_payment_types == total_payment_types) {
      //   //   params = {
      //   //     status: true,
      //   //     data: {
      //   //       ...tabledata,
      //   //       id: id ? id : "",
      //   //       subtotal: totals?.subtotal,
      //   //       taxamount: totals?.taxamount,
      //   //       discount: totals?.discount,
      //   //       delivery: totals?.delivery,
      //   //       delivery_status: totals?.delivery_status,
      //   //       delivery_date: totals?.delivery_date,
      //   //       payment_status: totals?.payment_status,
      //   //       payment_types: totals?.payment_types,
      //   //       payments: totals?.payments,
      //   //       total: totals?.total,
      //   //     },
      //   //   };
      //   //   return params;
      //   // }
      //   else {
      //     params = {
      //       status: false,
      //       data: null,
      //     };

      //     return params;
      //   }
      //   // }
      // } else {
      //   params = {
      //     status: true,
      //     data: {
      //       ...tabledata,
      //       id: id ? id : "",
      //       subtotal: totals?.subtotal,
      //       taxamount: totals?.taxamount,
      //       discount: totals?.discount,
      //       delivery: totals?.delivery,
      //       delivery_status: totals?.delivery_status,
      //       delivery_date: totals?.delivery_date,
      //       payment_status: totals?.payment_status,
      //       payment_types: totals?.payment_types,
      //       payments: totals?.payments,
      //       total: totals?.total,
      //       status: 1,
      //     },
      //   };

      //   return params;
      // }

      if (count_totals) {
        if (totals?.payment_types?.length > 0) {

          if (totals?.payment_types?.length === 1) {
            total_amount = parseFloat(totals?.total || 0);
            params = {
              status: true,
              data: {
                ...tabledata,
                id: id ? id : "",
                subtotal: totals?.subtotal,
                taxamount: totals?.taxamount,
                discount: totals?.discount,
                delivery: totals?.delivery,
                delivery_status: 2,
                delivery_date: new Date(),
                payment_status: 2,
                payment_types: totals?.payment_types,
                payments: [{
                  name: totals?.payment_types[0],
                  amount: totals?.total
                }],
                total: totals?.total,
              },
            };
            return params;
          }
          else {
            let count_payment_types = 0;

            totals?.payment_types?.forEach((type, i) => {
              if (count_payment_types == i) {
                const paymentsOfType = totals?.payments?.filter(p => p.name === type) || [];
                const totalForType = paymentsOfType.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

                if (totalForType <= 0) {
                  document.getElementById(
                    `payment_type_${type}`
                  ).textContent = `${type} payment is required`;
                  focus.current[`payment_type_${type}`]?.current?.focus();
                } else {
                  total_amount = parseFloat(total_amount || 0) + totalForType;
                  document.getElementById(`payment_type_${type}`).textContent = ``;
                  count_payment_types++;
                }
              }
            });

            if (total_amount > parseFloat(totals?.total || 0)) {
              toast?.error(`Total payments (${total_amount.toFixed(3)}) exceed order total (${parseFloat(totals?.total).toFixed(3)})`);
              params = { status: false, data: null };
              return params;
            }

            if (count_payment_types == totals?.payment_types?.length) {
              params = {
                status: true,
                data: {
                  ...tabledata,
                  id: id ? id : "",
                  subtotal: totals?.subtotal,
                  taxamount: totals?.taxamount,
                  discount: totals?.discount,
                  delivery: totals?.delivery,
                  delivery_status: totals?.delivery_status,
                  delivery_date: totals?.delivery_date,
                  payment_status: total_amount >= parseFloat(totals?.total) ? 2 : 1,
                  payment_types: totals?.payment_types,
                  payments: totals?.payments?.filter(p => p.amount && parseFloat(p.amount) > 0),
                  total: totals?.total,
                },
              };
              return params;
            }
          }
        } else {
          params = {
            status: true,
            data: {
              ...tabledata,
              id: id ? id : "",
              subtotal: totals?.subtotal,
              taxamount: totals?.taxamount,
              discount: totals?.discount,
              delivery: totals?.delivery,
              delivery_status: totals?.delivery_status,
              delivery_date: totals?.delivery_date,
              payment_status: 0, 
              payment_types: [],
              payments: [],
              total: totals?.total,
              status: 1,
            },
          };
          return params;
        }
      }

      return params;
    };
  };

  const formdata = async (data, print) => {
    if (buttonLoader) return;

    if (data?.status) {

      const tabledetailsvalidation = detailsvalidation(data?.data);

      if (tabledetailsvalidation?.status) {
        const tabletotalvalidation = totalsvalidation(
          tabledetailsvalidation?.data
        );

        if (tabletotalvalidation?.status) {
          setButtonLoader(true);

          /*  const normalizedPayments = totals?.payments
             ?.filter(p => p.amount && parseFloat(p.amount) > 0) || []; */

          let normalizedPayments = [];

          if (totals?.payment_types?.length === 1) {
            const singlePaymentType = totals?.payment_types[0];
            normalizedPayments = [{
              id: `temp-${singlePaymentType}-${Date.now()}`,
              name: singlePaymentType,
              amount: totals?.total?.toString() || "0"
            }];
          } else {
            normalizedPayments = totals?.payments
              ?.filter(p => p.amount && parseFloat(p.amount) > 0) || [];
          }

          const payload = {
            ...tabletotalvalidation?.data,
            payments: normalizedPayments,
            payment_status: normalizedPayments.length > 0 ?
              (parseFloat(normalizedPayments.reduce((sum, p) => sum + parseFloat(p.amount), 0)) >= parseFloat(totals?.total) ? 2 : 1)
              : 0
          };

          const invoice = id
            ? await update_invoice(payload)
            : await create_invoice(payload);
          if (invoice?.status) {
            if (id) {
              navigate(-1);
            } else {
              navigate(0);
            }
            toast?.success(invoice?.message);
            setDetails([
              {
                id: "",
                description: null,
                name: "",
                unit: "",
                unit_name: "",
                unit_details_options: null,
                conversion: 0,
                quantity: "",
                invoice: "",
                invoice_price: "",
                invoice_options: null,
                delivered: "",
                tax: 0,
                free: "",
                barcode: "",
                price_per_unit: "",
                sale_price: "",
                expiry_date: "",
                tax_amount: "0.000",
                total: 0,
              },
            ]);
            setTotals({
              subtotal: "0.000",
              taxamount: "0.000",
              discount: 0,
              delivery: 0,
              delivery_status: 2,
              delivery_date: new Date(),
              payment_status: 2,
              payment_types: ["Cash"],
              /*  payments: {
                 Cash: "",
                 Cheque: "",
                 "Debit card": "",
                 "Credit card": "",
                 "Bank transfer": "",
                 "Online payment": "",
               }, */
              payments: [],
              paid: 0,
              remaining: 0,
              total: "0.000",
            });
            setCustomerPay();
            setButtonLoader(false);
          } else {
            setButtonLoader(false);

            if (invoice?.status_code == 403) {
              window.location.href = "/unauthorized";
            } else {
              toast?.error(invoice?.message);
            }
          }
        }
      }
    }
  };

  const handleData = (invoice) => {
    let customer = invoice?.customer?._id ? invoice?.customer?._id : null;
    let number = invoice?.number ? invoice?.number : "";
    let date = invoice?.date ? invoice?.date : "";
    let due_date = invoice?.due_date ? invoice?.due_date : "";
    let lpo_number = invoice?.lpo_number ? invoice?.lpo_number : "";
    let lpo_date = invoice?.lpo_date ? invoice?.lpo_date : "";
    let reference = invoice?.reference?._id ? invoice?.reference?._id : null;
    let status = invoice?.status ? invoice?.status : 0;

    let reference_options = invoice?.reference?._id
      ? [
        {
          value: invoice?.reference?._id,
          label: invoice?.reference?.name,
        },
      ]
      : null;

    let customer_option = invoice?.customer?._id
      ? [
        {
          value: invoice?.customer?._id,
          label:
            invoice?.customer?.name && invoice?.customer?.phone
              ? invoice?.customer?.name +
              " (" +
              invoice?.customer?.phone +
              ")"
              : invoice?.customer?.name
                ? invoice?.customer?.name
                : invoice?.customer?.phone
                  ? invoice?.customer?.phone
                  : "",
        },
      ]
      : null;

    let data = [];

    invoice?.details?.map((value, index) => {
      let stock = value?.description?.stock;

      if (value?.unit != value?.description?._id) {
        value?.inventory_unit_details?.map((v, i) => {
          if (value?.unit == v?._id) {
            stock = v?.stock;
          }
        });
      }

      data?.push({
        id: value?._id,
        description: value?.description?._id,
        batch: value?.description?.number,
        expiry_date: value?.description?.expiry_date,
        stock: stock,
        name: value?.name,
        unit: value?.unit,
        unit_name: value?.unit_name,
        unit_details_options: value?.unit_details_options,
        conversion: value?.conversion,
        invoice_price: value?.invoice_price,
        quantity: value?.quantity,
        delivered: value?.delivered,
        free: value?.free,
        tax: value?.tax,
        barcode: value?.barcode,
        price_per_unit: value?.price_per_unit,
        sale_price: value?.sale_price,
        retail_price: value?.description?.product?.sale_price,
        expiry_date: value?.expiry_date,
        tax_amount: value?.tax_amount,
        total: value?.total,
      });
    });

    /* let payment_types = [];
    let payments = {};
    invoice?.payments?.map((v, i) => {
      payment_types?.push(v?.name);
      payments[v?.name] = { id: v?._id, amount: v?.amount };
    }); */

    let payment_types = [];
    let payments = [];

    invoice?.payments?.forEach((payment) => {
      if (!payment_types.includes(payment?.name)) {
        payment_types.push(payment?.name);
      }

      payments.push({
        id: payment?._id || `temp-cash-initial`,
        name: payment?.name,
        amount: payment?.amount
      });
    });

    totals.subtotal = invoice?.subtotal;
    totals.taxamount = invoice?.taxamount;
    totals.discount = invoice?.discount;
    totals.delivery = invoice?.delivery;
    totals.delivery_status = invoice?.delivery_status;
    totals.delivery_date = invoice?.delivery_date;
    totals.payment_status = invoice?.payment_status;
    totals.payment_types = payment_types;
    totals.payments = payments;
    totals.total = invoice?.total;

    setValues([...values]);
    setDetails([...data]);
    setTotals({ ...totals });
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const invoice = await get_invoice(data);
      if (invoice?.status) {
        handleData(invoice?.data);
      } else {
        toast?.error(invoice?.message);
      }
    } else {
      // values[0].options[2].form.value = new Date();
      // values[0].options[3].form.value = new Date();

      totals.delivery_status = 2;
      totals.delivery_date = new Date();
      totals.payment_status = 2;

      setValues([...values]);
      setTotals({ ...totals });
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Loadercomponent loader={loader}>
      <Forms
        form={values}
        setForm={setValues}
        formdata={formdata}
        buttonLoader={buttonLoader}
      >
        <Bodycomponent>
          <Titlecomponent index={1} title={"Items"} />
          <Formdata>
            <Headercomponent index={0} name={"Details"} required={true} />
            <BillingTable
              details={details}
              setDetails={setDetails}
              totals={totals}
              setTotals={setTotals}
              customer={customer}
              setCustomer={setCustomer}
              refrence={refrence}
              setReference={setReference}
              customerPay={customerPay}
              setCustomerPay={setCustomerPay}
              ref={focus}
            />
          </Formdata>
        </Bodycomponent>
      </Forms>
    </Loadercomponent>
  );
};

export default BillingForm;
